import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { CalendarSchedulePlusIcon } from '@moia-dev/pace-icons'
import { ShiftsCreationAreaRoutes } from './ShiftsCreationAreaRoutes'

export const ShiftsCreationAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ShiftsCreationAreaRoutes.route}
      Icon={CalendarSchedulePlusIcon}
    />
  )
}
